import { render, staticRenderFns } from "./HotelBookingForSuperintendent.vue?vue&type=template&id=5b4a15d0&"
import script from "./HotelBookingForSuperintendent.vue?vue&type=script&lang=js&"
export * from "./HotelBookingForSuperintendent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports